import { z } from 'zod';

import { AchBatchTransactionId } from '../BrandedIds';
import { zodDateOrString } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const NachaMarkAsProcessedEvent = BaseLoanEvent.extend({
  type: z.literal('nachaMarkAsProcessed'),
  transactionId: AchBatchTransactionId,
  processedDate: zodDateOrString,
});
export type NachaMarkAsProcessedEvent = z.infer<typeof NachaMarkAsProcessedEvent>;
